/** Показывать разделы «Результаты отборочного/очного этапа» в шапке и на главном экране */
export const SHOW_STAGE_RESULTS =
  process.env.REACT_APP_SHOW_STAGE_RESULTS === 'true';

/** Начало периода регистрации (включительно), формат YYYY-MM-DD */
export const REGISTRATION_START =
  process.env.REACT_APP_REGISTRATION_START ?? '2026-05-25';

/** Конец периода регистрации (включительно), формат YYYY-MM-DD */
export const REGISTRATION_END =
  process.env.REACT_APP_REGISTRATION_END ?? '2026-10-04';

function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Регистрация открыта в заданном периоде (включительно, по локальному времени) */
export function isRegistrationOpen(now: Date = new Date()): boolean {
  const current = startOfDay(now);
  const start = startOfDay(parseLocalDate(REGISTRATION_START));
  const end = startOfDay(parseLocalDate(REGISTRATION_END));
  return current >= start && current <= end;
}
